<script>
  import { getPlayersCountByGames } from "../../../#services/getPlayersCountByGames";

  let dd = String((new Date()).getDate()).padStart(2, '0')
  let mm = String((new Date()).getMonth() + 1).padStart(2, '0')
  let yyyy = (new Date()).getFullYear()
  let startDate = 'startDate'
  let endDate = 'endDate'

  const minDate = '2023-01-01';
  const maxDate = yyyy+'-'+mm+'-'+dd

  function setDate(days) {
    if (days > -1) {
      let d = new Date(maxDate);
      d.setDate(d.getDate() - days);
      let dd = String(d.getDate()).padStart(2, '0');
      let mm = String(d.getMonth() + 1).padStart(2, '0');
      let yyyy = d.getFullYear();
      startDate = yyyy+'-'+mm+'-'+dd;
      endDate = maxDate;
    } else {
      startDate = 'startDate';
      endDate = 'endDate';
    }
  }

  setDate(30);

  function refresh() {
    getPlayersCountByGames.send({ data: {
      startDate: startDate && startDate !== 'startDate' ? startDate : minDate,
      endDate: endDate && endDate !== 'endDate' ? endDate : maxDate,
    } });
  }

  refresh();
</script>

<div class="buttons">
  <div class="pc-line">
    <span class="date-label">From</span>
    <input type="date" bind:value={startDate} class="form-control" max="{maxDate}">
  </div>
  <div class="pc-line">
    <span class="date-label">To</span>
    <input type="date" bind:value="{endDate}" class="form-control" max="{maxDate}">
  </div>
  <div class="pc-line">
    <button class="btn btn-primary btn-filter" on:click={refresh}>Refresh</button>
  </div>
</div>

<div class="wrapper">
  <table class="table">
    <thead>
      <tr>
        <th></th>
        <th>Count</th>
        <th>Cats</th>
        <th>Dragons</th>
        <th>Foxes</th>
        <th>Dogs</th>
      </tr>
    </thead>
    <tbody>
      {#if $getPlayersCountByGames.loading}
          {#each [0,0,0,0] as idx}
              <tr>
                  <td><span class="loading transaction-loading"></span></td>
                  <td><span class="loading transaction-loading"></span></td>
                  <td><span class="loading transaction-loading"></span></td>
                  <td><span class="loading transaction-loading"></span></td>
                  <td><span class="loading transaction-loading"></span></td>
                  <td><span class="loading transaction-loading"></span></td>
              </tr>
          {/each}
      {:else if $getPlayersCountByGames.error || !$getPlayersCountByGames.hasValue}
          <tr>
              <td class="text-center" colspan="4">
                  {#if $getPlayersCountByGames.error}
                      {$getPlayersCountByGames.error}
                  {:else}
                      Something went wrong. Try refreshing the page.
                  {/if}
              </td>
          </tr>
      {:else}
          <tr>
            <td>Cats</td>
            <td>{$getPlayersCountByGames.value['cats']}</td>
            <td>—</td>
            <td>{($getPlayersCountByGames.value['cats,dragons'] * 100 / $getPlayersCountByGames.value['cats']).toFixed(1)} %</td>
            <td>{($getPlayersCountByGames.value['cats,foxes'] * 100 / $getPlayersCountByGames.value['cats']).toFixed(1)} %</td>
            <td>{($getPlayersCountByGames.value['cats,dogs'] * 100 / $getPlayersCountByGames.value['cats']).toFixed(1)} %</td>
          </tr>
          <tr>
            <td>Dragons</td>
            <td>{$getPlayersCountByGames.value['dragons']}</td>
            <td>{($getPlayersCountByGames.value['cats,dragons'] * 100 / $getPlayersCountByGames.value['dragons']).toFixed(1)} %</td>
            <td>—</td>
            <td>{($getPlayersCountByGames.value['dragons,foxes'] * 100 / $getPlayersCountByGames.value['dragons']).toFixed(1)} %</td>
            <td>{($getPlayersCountByGames.value['dragons,dogs'] * 100 / $getPlayersCountByGames.value['dragons']).toFixed(1)} %</td>
          </tr>
          <tr>
            <td>Foxes</td>
            <td>{$getPlayersCountByGames.value['foxes']}</td>
            <td>{($getPlayersCountByGames.value['cats,foxes'] * 100 / $getPlayersCountByGames.value['foxes']).toFixed(1)} %</td>
            <td>{($getPlayersCountByGames.value['dragons,foxes'] * 100 / $getPlayersCountByGames.value['foxes']).toFixed(1)} %</td>
            <td>—</td>
            <td>{($getPlayersCountByGames.value['foxes,dogs'] * 100 / $getPlayersCountByGames.value['foxes']).toFixed(1)} %</td>
          </tr>
          <tr>
            <td>Dogs</td>
            <td>{$getPlayersCountByGames.value['dogs']}</td>
            <td>{($getPlayersCountByGames.value['cats,dogs'] * 100 / $getPlayersCountByGames.value['dogs']).toFixed(1)} %</td>
            <td>{($getPlayersCountByGames.value['dragons,dogs'] * 100 / $getPlayersCountByGames.value['dogs']).toFixed(1)} %</td>
            <td>{($getPlayersCountByGames.value['foxes,dogs'] * 100 / $getPlayersCountByGames.value['dogs']).toFixed(1)} %</td>
            <td>—</td>
          </tr>
      {/if}
    </tbody>
  </table>
</div>

<style>
  .buttons {
    margin-bottom: 15px;
  }

  .buttons .btn {
    margin-left: 5px;
  }

  .btn-primary.btn-filter {
    padding: 8px 20px;
  }

  .form-select, .form-control {
    width: auto;
    display: inline-block;
    vertical-align: top;
  }

  input[type="date"] {
    width: auto;
    display: inline-block;
    vertical-align: top;
  }

  .date-label {
      padding: 0 5px;
      line-height: 38px;
      font-weight: 500;
  }

  .pc-line {
      display: inline-block;
      margin-bottom: 10px;
  }

  .wrapper {
    overflow-x: auto;
    position: relative;
  }

  .table {
    width: 100%;
    white-space: nowrap;
  }

  .table th {
    background-color: #e9ecef;
    padding-left: 15px;
    padding-right: 15px;
  }

  .table tr td {
    width: 200px;
    padding-left: 15px;
    padding-right: 15px;
  }

  .transaction-loading {
    height: 24px;
    width: 100%;
    display: block;
  }
</style>